import { combineReducers } from 'redux';

import allLeads from 'app/shared/reducers/lead/allLeads';
import lead from 'app/shared/reducers/lead/lead';
import leadsForListing from 'app/shared/reducers/lead/leadsForListing';

const rootLeadReducer = combineReducers({
    allLeads,
    lead,
    leadsForListing,
});

export default rootLeadReducer;
